import { Dispatch, FC, SetStateAction, memo } from 'react'
import { Flex, HStack, Text } from '@chakra-ui/react'

import { CheckCircle, Close } from 'components/icons'
import SlugActionsIcons from '../SlugActionsIcons'

type Props = {
  slug?: string
  isSlugValid: boolean | null
  setContext: Dispatch<SetStateAction<string>>
}

const SlugInput: FC<Props> = ({ isSlugValid, slug, setContext }) => {
  if (isSlugValid === null) {
    return (
      <HStack>
        <Text>Slug: {slug}</Text>
        <SlugActionsIcons setContext={setContext} />
      </HStack>
    )
  }

  return (
    <HStack spacing={1}>
      <Flex align="center" gap={1} color={isSlugValid ? 'success' : 'danger'}>
        <Text>Slug: {slug}</Text>
      </Flex>

      {isSlugValid ? (
        <CheckCircle color={isSlugValid ? 'success' : 'danger'} />
      ) : (
        <Close color="danger" boxSize={6} />
      )}
      <SlugActionsIcons setContext={setContext} />
    </HStack>
  )
}

export default memo(SlugInput)
